import { useEffect, useRef, useState } from 'react';

import AudioService from '@services/AudioService';

export const useAudioService = (enabled = true) => {
  const context = useRef(null);
  const [audioAvailable, setAudioAvailable] = useState(false);
  const [audioOpen, setAudioOpen] = useState(false);

  useEffect(() => {
    if (!enabled) return;
    const onPoll = ({ active }: { active: boolean }) => {
      setAudioAvailable(active);
    };
    AudioService.subscribe(30000, onPoll, context);
  }, [enabled]);

  useEffect(() => {
    if (!enabled) return;

    const interval = setInterval(() => {
      setAudioOpen(AudioService.open);
    }, 1000);

    return () => {
      clearInterval(interval);
    };
  }, [enabled]);

  const showButton = audioAvailable && !audioOpen;

  return { audioAvailable, audioOpen, showButton };
};
